<template>
  <div class="form__input">
    <label
      v-if="label"
      :for="id"
      :class="{ 'label--required': required }"
      class="label label--muted label--semibold"
    >
      {{ label }}
    </label>
    <div class="input" :class="{ 'input--disabled': disabled, 'input--errors': allErrors?.length }">
      <input
        v-model="model"
        v-bind="$attrs"
        v-maska="mask || undefined"
        ref="inputRef"
        :id="id"
        :placeholder="disabled ? null : placeholder"
        :disabled="disabled"
        :type="type"
        class="input__field"
        autocomplete="off"
      >
    </div>

    <t-errors :errors="allErrors" />
  </div>
</template>

<script setup>
import { useId, ref, computed, watch } from 'vue'
import { vMaska } from 'maska/vue'
import { TErrors } from '@shared/ui'
import { useFieldErrors } from '@shared/lib'

defineOptions({ inheritAttrs: false })

const props = defineProps({
  label: String,
  required: { type: Boolean, default: false },
  placeholder: { type: String, default: 'Введите значение' },
  disabled: Boolean,
  type: { type: String, default: 'text' },
  errors: Array,
  mask: String,
  name: String,
})

const { fieldErrors, clearFieldErrors } = useFieldErrors(props.name)
const allErrors = computed(() => props.errors ?? fieldErrors.value)

const id = useId()
const model = defineModel()
const inputRef = ref(null)

watch(model, () => { if (fieldErrors.value.length) clearFieldErrors() })

defineExpose({
  focus: () => inputRef.value?.focus(),
  blur: () => inputRef.value?.blur(),
})
</script>